import { useMediaQuery } from 'react-responsive';

export const useLg = () =>
  useMediaQuery({
    minWidth: 960,
  });
